import type { AxiosResponse } from 'axios';

import type { UserExperiencesResponse } from '@/interfaces/user';

import request from '../request';

export const getUserExperiences = async (): Promise<AxiosResponse<UserExperiencesResponse>> => {
  const response = await request({
    url: '/user/experiences',
  });
  return response;
};
